import { ApiError } from '@nebueye/shared'
import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'

/** Sent here when the API says the session is gone; the router redirects. */
const onAuthLost = (err: unknown) => {
  if (err instanceof ApiError && err.code === 'unauthenticated' && !location.pathname.startsWith('/sign-in')) {
    location.assign(`/sign-in?redirect=${encodeURIComponent(location.pathname + location.search)}`)
  }
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: onAuthLost }),
  mutationCache: new MutationCache({ onError: onAuthLost }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      // 4xx answers won't change on retry; network blips and 5xx might.
      retry: (count, err) => !(err instanceof ApiError && err.status >= 400 && err.status < 500) && count < 2,
    },
  },
})
